<template>
  <div class="c-idea-table">
    <el-table
      ref="table"
      :height="height"
      class="common-el-table-styles summary-el-table-styles"
      row-key="creativeId"
      :cell-class-name="cellClassName"
      v-loading="value"
      :data="data"
      show-summary
      stripe
      border
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
      :summary-method="getSummaries"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <el-switch
              v-model="scope.row.taskSwitchStatus"
              :active-value="1"
              :inactive-value="0"
              @change="changeActive(scope.row)"
              size="small"
            />
          </div>

          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="integrated(scope.row)">联调测试</el-button>
            <el-button type="text" v-if="isHasEdit" size="small" @click="editJob(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="jobSyc(scope.row)">同步数据</el-button>
          </div>
          <span v-else-if="col.key === 'adAccountSimpleName'">
            <div v-if="scope.row.editAdAccountSimpleName">
              <el-input
                placeholder=""
                v-model="scope.row.newAdAccountSimpleName"
                maxlength="15"
                style="width: 100px"
                class="inputStyle"
              ></el-input>
              <el-button type="primary" :loading="saving" size="small" @click="editAccountSimple(scope.row)" style="margin-left: 6px">
                <span v-if="!saving">确定</span>
              </el-button>
              <el-button size="small" @click="cancelEdit(scope.row, 'editAdAccountSimpleName')" style="margin-left: 6px">取消</el-button>
            </div>
            <div v-else>
              <span>{{ scope.row.adAccountSimpleName }}</span>
              <i
                @click="changEdit(scope.row, 'editAdAccountSimpleName', 'newAdAccountSimpleName', 'adAccountSimpleName')"
                class="el-icon-edit m-edit"
                style="font-size: 18px; color: #409eff"
              ></i>
            </div>
          </span>

          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'synTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'synStatus'">{{ col.format(scope) }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑任务 -->
    <el-dialog :visible.sync="editModal" title="编辑任务" width="510px">
      <div class="c-form ghost-button-styles">
        <ElForm label-width="120px">
          <ElFormItem label="媒体">
            <el-input disabled :value="mediaRow" />
          </ElFormItem>
          <ElFormItem label="账号">
            <el-input disabled :value="accountRow" />
          </ElFormItem>
          <ElFormItem label="告警">
            <el-switch v-model="alarmStatus" :active-value="1" :inactive-value="0" @change="changeActiveEdit()" />
          </ElFormItem>
          <ElFormItem v-if="alarmStatus === 1">
            <el-radio-group v-model="alarm" @change="selectAlarmType()">
              <el-radio-button ghost label="1" :disabled="label1">钉钉</el-radio-button>
              <el-radio-button ghost label="2" :disabled="label2">邮件</el-radio-button>
              <el-radio-button ghost label="3" :disabled="label3">钉钉+邮件</el-radio-button>
            </el-radio-group>
          </ElFormItem>
          <ElFormItem label="告警人员选择" v-if="alarmStatus === 1">
            <el-select v-model="alertUser" multiple collapse-tags filterable clearable placeholder="请选择人员" style="width: 100%">
              <el-option v-for="item in SYS_USERS" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="数据关联模式">
            <el-radio-group v-model="raRadio" v-if="isIncludeMediaIds(mediaIdsRow)" @change="onSelectRadio">
              <el-radio label="3">按名称1对1匹配</el-radio>
              <el-radio label="4">合并汇总到1条计划上</el-radio>
            </el-radio-group>
            <el-radio-group v-model="raRadio" v-else>
              <el-radio label="5">计划名称匹配</el-radio>
            </el-radio-group>
          </ElFormItem>
          <ElFormItem label="选择计划" v-if="planSwitch === '1'">
            <el-select
              v-model="planIdss"
              collapse-tags
              filterable
              clearable
              :popper-append-to-body="false"
              label-in-value="true"
              placeholder="请选择计划"
              style="width: 180px; overflow: hidden"
              @change="handelSelectChange"
            >
              <el-option v-for="item in planData" :key="item.planId" :value="item.planId" :label="item.planName"></el-option>
            </el-select>
          </ElFormItem>

          <template v-if="mediaIdsRow === 193">
            <el-form-item label="自动创建关键词计划">
              <el-switch v-model="isAutoCreatePlan"></el-switch>
            </el-form-item>
            <el-form-item label="游戏选择" v-if="isAutoCreatePlan">
              <el-select v-model="asaGameId" :popper-append-to-body="false" clearable collapse-tags filterable placeholder="全部">
                <el-option v-for="item in POPULAR_GAMES" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </template>

          <!-- 只有腾讯广告才显示的提示文字 v4.27.0 20230707 -->
          <!-- <ElFormItem v-if="mediaIdsRow === 16">
            <p style="color: red">注：按照名称做匹配，广告层级未匹配到，用推广计划做匹配</p>
          </ElFormItem> -->
        </ElForm>
      </div>
      <span slot="footer">
        <el-button @click="cancelEditJob">取消</el-button>
        <el-button type="primary" @click="editJobSubmit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="jobTestModal" title="联调测试" width="460px" @close="cancelTestJob">
      <div class="c-form c-test">
        <ElForm label-width="110px">
          <ElFormItem label="媒体">
            <span>{{ mediaRow }}</span>
            <input type="hidden" :value="mediaIdRow" />
            <input type="hidden" :value="taskIdTest" />
          </ElFormItem>
          <ElFormItem label="账号">
            <span>{{ accountRow }}</span>
            <input type="hidden" :value="accountIdRow" />
          </ElFormItem>
          <ElFormItem label="联调时间范围">
            <DateRangePicker v-model="datetime" style="width: 220px"></DateRangePicker>

            <el-tooltip placement="top">
              <div slot="content">
                <p>1.联调时间建议在有消耗数据时间范围内</p>
                <p>2.联调时间范围过大,可能导致联调失败</p>
              </div>
              &ensp;<i class="el-icon-info" style="font-size: 18px"></i>
            </el-tooltip>
          </ElFormItem>
          <el-form-item label="创建汇总计划">
            <div class="summary-switch">
              <el-switch v-model="isSummary" :disabled="![10, 16, 32, 45].includes(mediaIdRow)"></el-switch>
              <el-tooltip effect="dark" placement="top">
                <div style="width: 320px" slot="content">
                  <p>说明：</p>
                  <p>1、开启该开关时，会根据设置在账号内创建一条计划；</p>
                  <p>
                    2、账号内的所有的消耗会同步汇总在【该条计划】里面；如果后续不想做汇总该计划，可以在【同步任务】-【编辑】里面转换【数据匹配模式】为【合并汇总到1条计划上】
                  </p>
                  <p>3、目前仅支持头条、腾讯、快手、百度</p>
                </div>
                <span class="el-icon-warning-outline"></span>
              </el-tooltip>
            </div>
          </el-form-item>
          <template v-if="isSummary">
            <el-form-item label="游戏选择">
              <el-select v-model="gameId" :popper-append-to-body="false" clearable collapse-tags filterable placeholder="全部">
                <el-option v-for="item in POPULAR_GAMES" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消耗归属">
              <p>该账号的所有计划消耗会合计同步到【该条新建的汇总计划上面】</p>
            </el-form-item>
            <el-form-item label="计划名称">
              <p>汇总计划-【账号名称】-【新建时间】</p>
            </el-form-item>
          </template>

          <ElFormItem v-if="testWarningMsg && jobTestModal">
            <div style="display: block; color: red; line-height: 16px">
              失败原因：<span>{{ testWarningMsg }}</span>
            </div>
          </ElFormItem>
        </ElForm>
      </div>

      <span slot="footer">
        <el-button @click="cancelTestJob">取消</el-button>
        <el-button type="primary" @click="testJob" :loading="loadingStatus">联调测试</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="jobSycModal" title="同步数据" width="520px">
      <div class="c-form c-test">
        <ElForm label-width="160px">
          <input type="hidden" :value="taskId" />
          <ElFormItem label="媒体">
            <span>{{ mediaRow }}</span>
          </ElFormItem>
          <ElFormItem label="账号">
            <span>{{ accountRow }}</span>
          </ElFormItem>
          <ElFormItem label="联调时间范围">
            <DateRangePicker v-model="datetime" :append-to-body="false" style="width: 220px"></DateRangePicker>

            <span style="display: block; color: #ff6400; height: 24px">1.请选择有消耗的时间范围</span>
            <span style="display: block; color: #ff6400; height: 24px">2.爬取的离线数据跨度天数不能超过31天</span>
            <span style="display: block; color: #ff6400; height: 24px">时间跨度过长可能导致同步页面无反应</span>
          </ElFormItem>
        </ElForm>
      </div>
      <span slot="footer">
        <el-button @click="cancelJobSyc">取消</el-button>
        <el-button type="primary" @click="sycJob" :loading="sycLoadingStatus">联调测试</el-button>
      </span>
    </el-dialog>

    <!-- 批量联调 -->
    <MediaDataSyncBatchModal
      :list.sync="selectedSyncRows"
      :visible.sync="showMediaDataSyncBatchModal"
      enable-import-accounts
      enable-summary
      @refresh="$emit('on-refresh')"
    ></MediaDataSyncBatchModal>
    <!-- 批量转账、充值 -->
    <AccountsRechargeTransferModal
      :list.sync="selectedRechargeTransferRows"
      :visible.sync="showRechargeTransferModal"
      @result="showBatchActionResultModal"
      @reset-list="onRechargeTransferListReset"
    ></AccountsRechargeTransferModal>
    <!-- 转账、充值结果 -->
    <AccountsRechargeTransferResultModal
      :result="rechargeTransferResult"
      :visible.sync="showRechargeTransferResultModal"
    ></AccountsRechargeTransferResultModal>
    <ToutiaoAddAvatarModal :visible.sync="showToutiaoAddAvatarModal" :ad-account-ids="toutiaoAdAccountIds"></ToutiaoAddAvatarModal>
  </div>
</template>
<script>
import mixin from './mixin'
import { setLocalInfo, timeout, formatDate } from '@/common/js/utils'
import { clone } from '@/common/js/just.js'
import { getSysMember } from '@/api/common.model'
import {
  adAccountEditBase,
  spiderJobConnectTest,
  syndata,
  updateWhiteList,
  batchOpenOrClose,
  openorclose,
  queryPlansBymediaId,
  updatetaskplan,
  getTask
} from '@/api/ptom.data.model'

import DateRangePicker from '@/components/date-range-picker'
import MediaDataSyncBatchModal from './media-batch-sync.vue'
import AccountsRechargeTransferModal from './accounts-batch-recharge-transfer/index.vue'
import AccountsRechargeTransferResultModal from './accounts-batch-recharge-transfer/result.vue'
import ToutiaoAddAvatarModal from './toutiao-add-avatar/index.vue'
import { platformEnum, mediaTypeEnum } from './accounts-batch-recharge-transfer/data.js'
import { initPageData, SYS_USERS, POPULAR_GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, POPULAR_GAMES])
const now = formatDate(new Date(), 'yyyy-MM-dd')
const TIMESTAMP = Date.parse(new Date()) - 60 * 60 * 24 * 1000
const yesterday = formatDate(new Date(TIMESTAMP), 'yyyy-MM-dd')
export default {
  mixins: [mixin],
  components: {
    DateRangePicker,
    MediaDataSyncBatchModal,
    AccountsRechargeTransferModal,
    AccountsRechargeTransferResultModal,
    ToutiaoAddAvatarModal
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    sumdata: {},
    media: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiao'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencent'
      else if (this.media === 45) name = 'create/baidu'
      else if (this.media === 32) name = 'create/kuaishou'
      return name
    },
    isHasEdit() {
      return this.access.includes('M20895')
    }
  },
  methods: {
    /**
     * @description: 批量同步、联调
     */
    onDataSyncBatchAction() {
      if (!this.selectList?.length) {
        return this.$Message.warning('请至少选择一个任务')
      }
      this.selectedSyncRows = clone(this.selectList)
      this.showMediaDataSyncBatchModal = true
    },

    /**
     * @description: 显示批量充值、转账操作后的结果弹窗
     */
    showBatchActionResultModal(res) {
      this.showRechargeTransferResultModal = true

      // 组合res内接口返回的内容
      const taskList = this.selectedRechargeTransferRows.map((item, index) => {
        const newItem = res.taskList[index]
        return { ...item, result: newItem }
      })

      this.rechargeTransferResult = {
        ...res,
        taskList
      }

      // 刷新结果
      this.$emit('on-refresh')
    },
    /**
     * @description: 切换充值、转账处理方式时，重置列表数据
     */
    onRechargeTransferListReset() {
      this.onAccountRechargeTransferAction()
    },

    /**
     * @description: 显示批量转账、充值弹窗；父组件调用次方法；
     */
    onAccountRechargeTransferAction() {
      if (!this.selectList?.length) {
        return this.$Message.warning('请至少选择一个任务')
      }
      this.selectedRechargeTransferRows = clone(this.selectList).map((item) => {
        // realBalance: 实际金额
        // transferFundType: 头条的账号类型：预付余额（bid_prepay_valid）和授信余额（bid_credit_valid），腾讯广告：授信余额（FUND_TYPE_CREDIT_ROLL）和现金余额（FUND_TYPE_CASH）
        // platform 充值平台类型，默认安卓联运
        // isSelfDeal  是否自行转账，1：自行，0：财务，头条腾讯广告默认自行转账
        // realtimeBalance 获取的实时余额（只有腾讯广告和头条）
        // loading: 当前行获取可用账号时的loading
        const isSelfDeal = [mediaTypeEnum.TOUTIAO, mediaTypeEnum.GDT].includes(item.mediaId) ? 1 : 0
        return {
          ...item,
          platform: platformEnum.androidUnion,
          realBalance: '',
          transferFundType: '',
          isSelfDeal,
          realtimeBalance: {},
          loading: false
        }
      })
      this.showRechargeTransferModal = true
    },

    /**
     * @description: 批量更新头条账号头像
     * @return {*}
     */
    onToutiaoMediaAddAvatar() {
      const toutiaoRows = this.selectList.filter((row) => row.mediaId === mediaTypeEnum.TOUTIAO)
      if (!toutiaoRows?.length) {
        return this.$Message.warning('请至少选择一个头条任务')
      }
      if (toutiaoRows.length !== this.selectList.length) {
        this.$Message.warning({
          content: '所选的账号内有【非头条】的账号，该功能只支持【头条】账号，已自动过滤。',
          duration: 5
        })
      }
      this.showToutiaoAddAvatarModal = true
      this.toutiaoAdAccountIds = toutiaoRows.map((row) => row.accountId)
    },

    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    setAlert() {},
    handelSelectChange(data) {
      this.planIds = data
      this.planName = this.planData.filter((ret) => ret.planId === data)[0].planName
    },
    onSelectRadio() {
      if (this.raRadio === '4') {
        this.planSwitch = '1'
        queryPlansBymediaId({ mediaId: this.mediaIdsRow, accountId: this.accountIdRow })
          .then((data) => {
            this.planData = data.list
          })
          .catch((err) => {
            this.$Message.error(err)
          })
      } else if (this.raRadio === '3') {
        this.planSwitch = '0'
      }
    },
    selectionFn(selection) {
      this.selectTag = selection
    },
    selectOk() {
      const list = []
      if (this.selectTag && this.selectTag.length) {
        this.selectTag.forEach((ret) => {
          list.push(...ret.words)
        })
      }
      const words = list.map((ret) => {
        return {
          id: ret.word_id,
          name: ret.word
        }
      })
      this.valid(words)
    },
    bindGetData(val) {},
    changeActiveEdit() {
      if (this.alarmStatus === 1) {
        this.label1 = false
        this.label2 = false
        this.label3 = false
        this.alertUserStatus = false
        this.alarm = '1'
      } else {
        this.label1 = true
        this.label2 = true
        this.label3 = true
        this.alertUserStatus = true
      }
    },
    onTestModalVisibleChange(v) {
      if (!v) {
        this.testWarningMsg = ''
      }
    },
    cancelTestJob() {
      this.jobTestModal = false
      this.testWarningMsg = ''
      this.isSummary = false
    },
    cancelEditJob() {
      this.editModal = false
      this.alarmStatus = 0
      this.alarm = 1
      this.label1 = true
      this.label2 = true
      this.label3 = true
      this.alertUser = ''
      this.planIdss = ''
      this.planSwitch = 0
    },
    cancelJobSyc() {
      this.jobSycModal = false
    },
    async rebuildSummaryPlanConfirm(taskId) {
      const taskInfo = await this.getTaskInfoById(taskId)
      const extInfo = JSON.parse(taskInfo.extInfo)

      if (extInfo && extInfo.planId && extInfo.planName) {
        return this.$confirm(`已经创建过汇总计划【${extInfo.planName}】是否继续进行创建？`, '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }

      return Promise.resolve()
    },
    async testJob() {
      const params = {}
      const [testConBegin, testConEnd] = this.datetime || []
      if (!testConBegin || !testConEnd) return this.$Message.warning('请选择时间范围')
      if (this.isSummary && !this.gameId) return this.$Message.warning('请选择游戏')
      params.accountId = this.accountIdRow
      params.mediaId = this.mediaIdRow
      params.taskId = this.taskIdTest
      params.testConBegin = testConBegin
      params.testConEnd = testConEnd
      if (this.isSummary) {
        params.gameId = this.gameId
      }
      if (params.testConBegin && params.testConEnd) {
        this.loadingStatus = true

        if (this.isSummary) {
          try {
            await this.rebuildSummaryPlanConfirm(params.taskId)
          } catch (e) {
            console.log('eeeeeeeee output: ', e)
            this.loadingStatus = false
            return false
          }
        }

        spiderJobConnectTest(params)
          .then((data) => {
            if (data.result.success) {
              if (this.jobTestModal) {
                this.$Message.success(data.message)
              }

              this.loadingStatus = false
              this.$emit('on-refresh')
              timeout(1000).then(() => {
                this.jobTestModal = false
              })
            } else {
              this.loadingStatus = false
              if (this.jobTestModal) {
                this.testWarningMsg = data.message
              }
            }
          })
          .catch(() => {
            this.loadingStatus = false
          })
      } else if (!params.testConBegin && !params.testConEnd) {
        this.$Message.warning('请选择联调时间!')
        timeout(0).then(() => {
          this.asyning = false
        })
      } else {
        timeout(600).then(() => {
          this.$emit('on-select', this.currentRow)
        })
      }
    },

    isIncludeMediaIds(mediaId) {
      return [10, 16, 62, 46, 193, 45, 32].includes(Number(mediaId))
    },

    editJobSubmit() {
      const params = Object.assign({}, this.app)
      const extInfos = Object.assign({}, this.app)
      const planInfos = Object.assign({}, this.app)
      params.mediaId = this.mediaIdsRow
      params.accountId = this.accountIdRow
      params.taskId = this.taskId
      if (this.alarmStatus === 0) {
        params.alarmStatus = 0
      } else {
        params.alarmType = this.alarm
        params.alarmStatus = 1
      }

      if (this.alertUser) {
        params.userIds = this.alertUser.join(',')
      }

      if (this.isIncludeMediaIds(this.mediaIdsRow)) {
        planInfos.planName = this.planName
        planInfos.planId = this.planIds
        if (this.mediaIdsRow === 193) {
          if (this.isAutoCreatePlan) {
            if (!this.asaGameId) return this.$Message.warning('请选择游戏')
            planInfos.gameId = this.asaGameId
          }
        }
        params.extInfo = planInfos
        if (this.alarmStatus === 0) {
          params.alarmType = 0
          params.alarmStatus = 0
          params.userIds = ''
        }
      } else {
        params.extInfo = {}
        if (this.alarmStatus === 0) {
          params.alarmType = 0
          params.alarmStatus = 0
          params.userIds = ''
        }
      }

      if (this.mediaIdsRow && this.taskId) {
        updatetaskplan(params)
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              this.editModal = false
              this.alarmStatus = 0
              this.alarm = 1
              this.label1 = true
              this.label2 = true
              this.label3 = true
              this.alertUser = ''
              this.planIdss = ''
              this.planSwitch = 0
            } else {
              this.editModal = true
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (!this.modalMedia) {
        this.$Message.warning('您未选择一个素材')
        this.asyning = true
        timeout(0).then(() => {
          this.asyning = false
        })
      } else {
        timeout(600).then(() => {
          this.state = false
          this.$emit('on-select', this.currentRow)
        })
      }
    },
    sycJob() {
      const params = Object.assign({}, this.app)
      params.taskId = this.taskId
      params.synBeginTime = this.datetime[0]
      params.synEndTime = this.datetime[1]
      if (params.synBeginTime && params.synEndTime) {
        this.sycLoadingStatus = true
        syndata(params)
          .then((data) => {
            if (data.result) {
              if (this.jobSycModal) {
                this.$Message.success(data.msg)
              }
              this.sycLoadingStatus = false
              timeout(1000).then(() => {
                this.jobSycModal = false
                this.$emit('on-refresh')
              })
            } else {
              this.sycLoadingStatus = false
              if (this.jobSycModal) {
                this.$Message.warning(data.msg)
              }
            }
          })
          .catch(() => {
            this.sycLoadingStatus = false
            this.show = false
          })
      } else if (!params.synBeginTime && !params.synEndTime) {
        this.$Message.warning('请选择联调时间!')
        timeout(0).then(() => {
          this.asyning = false
        })
      } else {
        timeout(600).then(() => {
          this.$emit('on-select', this.currentRow)
        })
      }
    },
    importWord() {
      this.show = true
      this.jobTestModal = true
      this.selectTag = []
      this.loading = false
    },
    sendSaveClick() {
      this.$nextTick(() => {
        this.$refs.filter && this.$refs.filter.saveFilter()
      })
    },
    // getSummaries (param) {
    //   this.$emit('on-sum', param)
    // },
    // 合计自定义
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        if (['lastMonthAmount', 'lastThreeDaysConsume', 'yestMoney', 'accountMoney'].includes(prop)) {
          sums[index] = this.sumdata[prop]
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    integrated(row) {
      this.loadingStatus = false
      this.mediaRow = row.mediaName
      this.accountRow = row.adAccount
      this.mediaIdRow = row.mediaId
      this.accountIdRow = row.accountId
      this.jobTestModal = true
      this.taskIdTest = row.taskId
      this.datetime = [yesterday, now]
    },
    jobSyc(row) {
      this.sycLoadingStatus = false
      this.mediaRow = row.mediaName
      this.accountRow = row.adAccount
      this.taskId = row.taskId
      this.jobSycModal = true
      this.datetime = [yesterday, now]
    },

    getTaskInfoById(taskId) {
      return getTask({ taskId })
    },
    editJob(row) {
      this.taskId = row.taskId
      this.accountRow = row.adAccount
      this.accountIdRow = row.accountId
      queryPlansBymediaId({ mediaId: row.mediaId, accountId: row.accountId })
        .then((data) => {
          this.planData = data.list
        })
        .catch((err) => {
          this.$Message.error(err)
        })
      this.getTaskInfoById(row.taskId)
        .then((data) => {
          if (this.isIncludeMediaIds(row.mediaId)) {
            if (data.extInfo) {
              const extInfo = JSON.parse(data.extInfo)
              if (row.mediaId === 193) {
                this.isAutoCreatePlan = !!extInfo.gameId
                this.asaGameId = extInfo.gameId || ''
              }
              if (extInfo.planId) {
                this.raRadio = '4'
                this.planSwitch = '1'
                this.planIdss = Number(extInfo.planId)

                // this.planIdss = 1413693
              } else {
                this.raRadio = '3'
                this.planName = ''
                this.planIds = ''
              }
            }
            if (data.alarmType) {
              this.alarmStatus = 1
              this.label1 = false
              this.label2 = false
              this.label3 = false
              this.alarm = data.alarmType.toString()
              this.alertUser = data.idList
            }
          } else {
            if (data.alarmType) {
              this.alarmStatus = 1
              this.label1 = false
              this.label2 = false
              this.label3 = false
              this.alarm = data.alarmType.toString()
              this.alertUser = data.idList
              this.raRadio = '5'
            }
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
      this.mediaRow = row.mediaName
      this.mediaIdsRow = row.mediaId
      this.editModal = true
      if (this.isIncludeMediaIds(this.mediaIdsRow)) {
        this.raRadio = '3'
      } else {
        this.raRadio = '5'
      }
    },
    // 改变编辑状态
    changEdit(row, key, initKey, orginKey) {
      this.$set(row, initKey, row[orginKey])
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.$set(row, key, false)
    },
    // 开关
    changeActive(row) {
      const params = Object.assign({}, this.app)
      params.taskStatus = row.taskSwitchStatus
      params.taskId = row.taskId
      params.accountId = row.accountId
      if ([1, 0].includes(row.taskSwitchStatus)) {
        openorclose(params)
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              this.jobTestModal = false
            } else {
              this.$Message.warning(data.msg)
              this.integrated(row)
              timeout(1000).then(() => {
                if (row.taskSwitchStatus === 0) {
                  row.taskSwitchStatus = 1
                } else {
                  row.taskSwitchStatus = 0
                }
              })
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      }
    },
    select(val) {
      // this.selectList = val
      this.$emit('on-select', val)
      this.selectList = val
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何任务，请在列表中选择一个或多个任务再进行此操作。'
        })
        return
      }

      const easySelectList = Object.assign([], this.app)
      if (type === 1) {
        for (var i = 0; i < len; i++) {
          const params1 = Object.assign({}, this.app)
          params1.accountId = this.selectList[i].accountId
          params1.type = '1'
          easySelectList.push(params1)
        }
        updateWhiteList(Object.assign({}, { params: easySelectList }))
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              timeout(1000).then(() => {
                // this.jump()
              })
            } else {
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (type === 2) {
        for (var n = 0; n < len; n++) {
          const params2 = Object.assign({}, this.app)
          params2.accountId = this.selectList[n].accountId
          params2.type = '0'
          easySelectList.push(params2)
        }
        updateWhiteList(Object.assign({}, { params: easySelectList }))
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              timeout(1000).then(() => {
                // this.jump()
              })
            } else {
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (type === 3) {
        for (var m = 0; m < len; m++) {
          const params3 = Object.assign({}, this.app)
          params3.accountId = this.selectList[m].accountId
          params3.taskStatus = '1'
          params3.taskId = this.selectList[m].taskId
          easySelectList.push(params3)
        }
        batchOpenOrClose(Object.assign({}, { params: easySelectList }))
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              this.$emit('on-refresh')
              timeout(1000).then(() => {
                // this.jump()
              })
            } else {
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      } else if (type === 4) {
        for (var h = 0; h < len; h++) {
          const params4 = Object.assign({}, this.app)
          params4.accountId = this.selectList[h].accountId
          params4.taskStatus = '0'
          params4.taskId = this.selectList[h].taskId
          easySelectList.push(params4)
        }
        batchOpenOrClose(Object.assign({}, { params: easySelectList }))
          .then((data) => {
            if (data.result) {
              this.$Message.success(data.msg)
              this.$emit('on-refresh')
              timeout(1000).then(() => {
                // this.jump()
              })
            } else {
              this.$Message.warning(data.msg)
            }
          })
          .catch(() => {
            this.loading = false
            this.show = false
          })
      }
    },
    imageModeClasses(mode) {
      let className
      if (mode && mode.includes('VERTICAL')) {
        className = 'vertical-img'
      } else if (mode && mode.includes('GROUP')) {
        className = 'group-img'
      } else {
        className = 'image-img'
      }
      return className
    },
    showVideo(url) {
      window.open(url, '_blank')
    },
    clickGroup(row) {
      const { adGroupId, adGroupName } = row
      this.$store.commit('setIndexRoute', 'group')
      this.$router.push({
        name: 'advert',
        query: {
          media: this.media,
          id: adGroupId,
          name: encodeURI(adGroupName)
        }
      })
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    },
    // 修改账号简称
    editAccountSimple(row) {
      this.saving = true
      adAccountEditBase({
        id: row.accountId,
        adAccountSimpleName: row.newAdAccountSimpleName
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$emit('on-refresh')
        }
      })
    },
    cellClassName({ column }) {
      if (column.property === 'adAccountSimpleName') return 'ad-account-name'
      return ''
    }
  },
  data() {
    return {
      // 批量联调、同步弹窗
      showMediaDataSyncBatchModal: false,
      selectedSyncRows: [],

      // 批量充值、转账
      showRechargeTransferModal: false,
      selectedRechargeTransferRows: [],

      // 批量充值、转账结果弹窗
      showRechargeTransferResultModal: false,
      rechargeTransferResult: {},

      showToutiaoAddAvatarModal: false,
      toutiaoAdAccountIds: [],

      datetime: [],
      saving: null, // 修改请求状态
      selectList: [], // 选中
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      access: this.$store.state.accessAuth,
      model: '',
      loadingStatus: false,
      sycLoadingStatus: false,
      alarmStatus: 0,
      isAutoCreatePlan: false,
      isSummary: false,
      gameId: '',
      asaGameId: '',
      alarm: '1',
      label1: true,
      label2: true,
      label3: true,
      loading: null,
      show: null,
      raRadio: '1',
      switchTrue: true,
      switchFalse: false,
      mediaRow: '',
      planSwitch: '0',
      mediaIdsRow: '',
      accountRow: '',
      taskId: '',
      taskIdTest: '',
      mediaIdRow: '',
      params: [],
      planIds: '',
      planIdss: '',
      planName: '',
      accountIdRow: '',
      jobTestModal: false,
      jobSycModal: false,
      editModal: false,
      multiTaskStatus: '',
      // operatorData: '',
      planData: '',
      type: '',
      alertUser: [],
      importModal: null,
      inserestTag: [],
      testWarningMsg: '' // 联调失败时显示的错误信息
    }
  }
}
</script>
<style lang="scss" scoped>
.c-idea-table {
  position: relative;
  background-color: #fff;
}
.summary-switch {
  display: flex;
  align-items: center;
  height: 32px;
  span {
    margin-left: 5px;
  }
}
::v-deep .el-table {
  .ad-account-name {
    position: relative;

    &:hover {
      .m-edit {
        display: block;
      }
    }
    .m-edit {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      display: none;
    }
  }
}

::v-deep .c-test {
  .el-form-item {
    margin-bottom: 8px;
  }
}
</style>
